import { gql } from "@apollo/client";

export const GET_SURVEYS = gql`
  query GetSurveyDefinitions($filter: SurveyDefinitionFilterInput!) {
    getSurveyDefinitions(filter: $filter) {
      # Aliased to "items" so the shared ListingComponentProvider (Survey Management list)
      # can paginate the records; consumers read getSurveyDefinitions.items.
      items: surveyDefinitions {
        surveyId
        surveyName
        status
        sourcePartner
        partnerConfiguration {
          partnerSurveyId
          partnerSettings
        }
        questions {
          questionId
          questionTitle
          correctAnswer
          answerOptions {
            optionId
            optionText
          }
        }
      }
      errors {
        message
        code
      }
    }
  }
`;
